import { msalInstance } from "..";
import { loginRequest } from "./authConfig";

export const acquireUserDetails = async () => {
  return msalInstance.acquireTokenSilent(loginRequest).then((data) => {
    return data;
  });
};
